// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CryptoCheckoutEnvironmentJs from "./CryptoCheckoutEnvironment.js";

function detect(prim) {
  return CryptoCheckoutEnvironmentJs.detect();
}

function addEip6963Listener(prim) {
  return CryptoCheckoutEnvironmentJs.addEip6963Listener(prim);
}

function currentHref(prim) {
  return CryptoCheckoutEnvironmentJs.currentHref();
}

function queryParam(prim) {
  return CryptoCheckoutEnvironmentJs.queryParam(prim);
}

function routePaymentId(prim) {
  return CryptoCheckoutEnvironmentJs.routePaymentId();
}

function continueOnTop(prim) {
  CryptoCheckoutEnvironmentJs.continueOnTop(prim);
}

function handoffUrl(prim0, prim1) {
  return CryptoCheckoutEnvironmentJs.handoffUrl(prim0, prim1);
}

function walletLinks(prim) {
  return CryptoCheckoutEnvironmentJs.walletLinks(prim);
}

export {
  detect ,
  addEip6963Listener ,
  currentHref ,
  queryParam ,
  routePaymentId ,
  continueOnTop ,
  handoffUrl ,
  walletLinks ,
}
/* ./CryptoCheckoutEnvironment.js Not a pure module */
